import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {SurveyService} from '../../services/survey.service';
import {UserSurveyViewModel} from '../../viewModels/userSurveyViewModel';
import {PaymentStatuses} from '../../../shared/enums/paymentStatuses.enum';
import * as moment from 'moment';
import {Router} from '@angular/router';

@Component({
    selector: 'app-survey',
    templateUrl: './survey.component.html',
    styleUrls: ['./survey.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SurveyComponent implements OnInit {
    surveys: UserSurveyViewModel[];

    constructor(
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly surveyService: SurveyService,
        public readonly router: Router,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.surveyService.getUserSurveys().subscribe(surveys => {
            this.surveys = surveys.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    }

    formatDate(date: string) {
        return moment(date).format('DD.MM.YYYY');
    }

    redirectToSurvey(id: number) {
        this.router.navigate(['survey/answers', id]);
    }

}
